<div class="history-container">
  <!-- No Lead ID State -->
  @if ((leadId === null || leadId === undefined) && !loading && !error) {
    <div class="no-lead-state">
      <div class="no-lead-message">Loading lead information...</div>
    </div>
  }
  <app-history-log-viewer
    [logs]="logs"
    [loading]="loading"
    [error]="error"
    [isLoadingMore]="isLoadingMore"
    [isSearching]="isSearching"
    [sortOrder]="sortOptions.sortOrder"
    [searchTerm]="searchTerm"
    (retryLoad)="retryLoad()"
    (sortOrderChange)="onSortOrderChange($event)"
    (loadMore)="onLoadMore()">
  </app-history-log-viewer>
</div>


